import React, {PropsWithChildren} from "react"
import { ImageWrapperContainer, ImageWrapperContainerInner } from "./styledHomeBanner";

type HomeBannerVectorProps = {
  desktopVectorRight?: string | null | undefined
  desktopVectorLeft?: string | null | undefined
}

export const HomeBannerVector: React.FC<PropsWithChildren<HomeBannerVectorProps>> = ({ desktopVectorRight, desktopVectorLeft, children }) => {
  return (
    <ImageWrapperContainer>
      <ImageWrapperContainerInner
        vectorRightSrc={desktopVectorRight}
        vectorLeftSrc={desktopVectorLeft}
      >
        {children}
      </ImageWrapperContainerInner>
    </ImageWrapperContainer>
  )
}